import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state() {
    return {
      live: {
        id: null,
        type: 'live',
      },
      totalMessages: 0,
      page: 1,
      messages: [],
      messageToBeEdited: undefined, // Original message that we want to edit
      messageThatIsBeingEdited: undefined, // Copy of the message that we edit on
      modalIsShown: false,
      standaloneContent: undefined,
      form: undefined,
    };
  },
};
